<script setup lang="ts">
import { computed, defineProps } from "vue";
import { TarotSituationPredictionResponse } from "@/types/calculators";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  result: TarotSituationPredictionResponse;
}>();

const { t } = useI18n();

const cards = computed(() => [
  { key: "first-card", value: props.result.first_card },
  { key: "second-card", value: props.result.second_card },
  { key: "third-card", value: props.result.third_card },
]);
</script>

<template>
  <!-- CARDS IMAGES -->
  <div class="w-full flex justify-between mb-10 md:mt-10">
    <div v-for="card in cards" :key="card.key" class="text-center">
      <img
        :src="card.value.image_url"
        :alt="card.value.name"
        class="mb-4 h-[140px] w-20 md:h-[351px] md:w-[198px]"
      />
      <p
        class="font-normal md:font-medium text-sm md:text-2xl leading-[20px] md:leading-[32px] text-brown w-20 md:w-[198px]"
      >
        {{ card.value.name }}
      </p>
    </div>
  </div>

  <!-- CARDS DESCRIPTIONS -->
  <div class="text-brown text-left">
    <div v-for="card in cards" :key="card.key">
      <h5 class="font-semibold text-xl leading-[24px] mb-4">
        {{
          t(`calculators.tarot.situation-prediction.result-cards.${card.key}`, {
            name: card.value.name,
          })
        }}
      </h5>
      <p class="font-normal text-base leading-[20px] mb-5">
        {{ card.value.meaning }}
      </p>
      <p class="font-normal text-base leading-[20px] mb-10">
        <span class="font-bold">
          {{
            t("calculators.tarot.situation-prediction.result-cards.card-key")
          }}
        </span>
        {{ card.value.key }}
      </p>
    </div>
  </div>
</template>
